// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2N34w","productName":"Table_productName__h5lmI"};